import * as yup from "yup";

export const connectDatasourceSchema = yup.object().shape({});
